import { remplazarPorTildeASinTilde, filter } from "../../helpers/Buscador";
import { types } from "../../types/types";
import { SURGE_CARGA_IMAGENES_BUSQUEDA } from "../../utils/constants";
import { surgeTypes } from "./surgeTypes";

const initialState = {
  patologias: [],
  conceptos: [],
  resoluciones: [],
  matriculas: [],
  itemAuxs: [],
  practicasYDispositivos: [],
  solicitudes: [],
  paginacion: {},
  contadorSolicitudes: {},
  archivos: [],
  tipoArchivos: [],
  estados: [],
  trackingSolicitud: [],
  estadosImagenes: SURGE_CARGA_IMAGENES_BUSQUEDA.ALTO_COSTO?.toString(),
};

export const surgeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.abmPracticasAgrupadasTraerTiposSuccess:
      return {
        ...state,
        patologias: action.payload,
        itemAuxs: action.payload
      };
    case types.abmPracticasAgrupadasBuscarTipo:
      const itemsResults = state.itemAuxs.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(action.payload)))
      return {
        ...state,
        patologias: itemsResults
      };
    case surgeTypes.cleanPracticasYDispositivosSurge:
      return {
        ...state,
        practicasYDispositivos: [],
      };
    case types.abmBuscarPracticasDispositivos:
      var items = state.itemAuxs.filter(n => filter(remplazarPorTildeASinTilde(n.concepto), remplazarPorTildeASinTilde(action.payload)))
      return {
        ...state,
        practicasYDispositivos: items
      };

    case surgeTypes.cleanEstadosSolicitudes:
      return {
        ...state,
        estados: []
      };
    case surgeTypes.getEstadosSolicitudes:
      return {
        ...state,
        estados: action.payload
      };
    case surgeTypes.getPracticasYDispositivosSurge:
      return {
        ...state,
        practicasYDispositivos: action.payload
      };
    case surgeTypes.insertPracticaYDispositivoSurge:
      return {
        ...state,
        practicasYDispositivos: [...state.practicasYDispositivos, action.payload]
      };
    case surgeTypes.updatePracticaYDispositivoSurge:
      return {
        ...state,
        practicasYDispositivos: state.practicasYDispositivos.map(item => item.idPracticaDispositivo === action.payload.idPracticaDispositivo ? action.payload : item)
      };
    case surgeTypes.removePracticaYDispositivoSurge:
      return {
        ...state,
        practicasYDispositivos: state.practicasYDispositivos.filter(item => item.idPracticaDispositivo !== action.payload)
      };
    // CONCEPTOS
    case types.getConceptosSurge:
      return {
        ...state,
        conceptos: action.payload,
      };
    case types.cleanConceptosSurge:
      return {
        ...state,
        conceptos: [],
      };
    case types.insertConceptoSurge:
      return {
        ...state,
        conceptos: [...state.conceptos, action.payload],
      };
    case types.updateConceptoSurge:
      return {
        ...state,
        conceptos: state.conceptos.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      };
    case types.removeConceptoSurge:
      return {
        ...state,
        conceptos: state.conceptos.filter((item) => item.id !== action.payload),
      };
    // RESOLUCIONES
    case surgeTypes.getResolucionesSurge:
      return {
        ...state,
        resoluciones: action.payload,
      };
    // MATRICULAS
    case surgeTypes.getMatriculasSurge:
      return {
        ...state,
        matriculas: action.payload,
      };

    // SOLICITUDES
    case surgeTypes.getSolicitudesSurge:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case surgeTypes.getPaginacion:
      return {
        ...state,
        paginacion: action.payload,
      };
    case surgeTypes.getContadorSolicitudesSurge:
      return {
        ...state,
        contadorSolicitudes: action.payload,
      };
    case surgeTypes.updateSolicitudSurge:
      return {
        ...state,
        solicitudes: state.solicitudes.map((item) => item.id === action.payload.id ? { ...item, ...action.payload } : item),
      };
    case surgeTypes.getTrackingSolicitudSurge:
      return {
        ...state,
        trackingSolicitud: action.payload,
      };
    case surgeTypes.cleanTrackingSolicitudSurge:
      return {
        ...state,
        trackingSolicitud: [],
      };
    case surgeTypes.removeSolicitudSurge:
      return {
        ...state,
        solicitudes: state.solicitudes.filter(item => item.id !== action.payload)
      };
    // ARCHIVOS
    case surgeTypes.getTipoArchivos:
      return {
        ...state,
        tipoArchivos: action.payload,
      };
    case surgeTypes.cleanArchivosSolicitudes:
      return {
        ...state,
        archivos: [],
      };
    case surgeTypes.getArchivosSolicitudes:
      return {
        ...state,
        archivos: action.payload,
      };
    case surgeTypes.uploadArchivosSolicitudes:
      return {
        ...state,
        archivos: [...state.archivos, action.payload],
      };
    //BANDEJA IMAGENES
    case surgeTypes.getEstadosCargaImagenesSolicitudes:
      return {
        ...state,
        estadosImagenes: action.payload
      };
    case surgeTypes.getSolicitudesBandejaImagenesSurge:
      return {
        ...state,
        solicitudes: action.payload,
      };
    default:
      return state;
  }
};
